// extracted by mini-css-extract-plugin
export default {"loader":"media-replace_loader__D8uLX","title":"media-replace_title__t5zNB","space":"media-replace_space__hUQdW","checkbox":"media-replace_checkbox__qE42n"};